export function getChecklistSchema() {
  return [
    {
      name: "id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: false,
      readOnly: true,
      error: false,
    },

    {
      name: "Name",
      default: "",
      type: "string",
      maxLength: 50,
      selectables: [],
      similair: [],
      nullable: false,
      readOnly: false,
      helperText: "Name is required",
      error: false,
    },
    {
      name: "Type",
      default: "",
      type: "string",
      maxLength: 50,
      selectables: [
        "Pre-Functional",
        "Receipt Inspection",
        "Functional Testing",
      ],
      similair: [],
      nullable: true,
      readOnly: false,
      helperText: "Type is required",
      error: false,
    },
    {
      name: "rows",
      default: "",
      type: "array",
      maxLength: 20,
      selectables: [],
      similair: [],
      nullable: false,
      readOnly: true,
      helperText: "",
      error: false,
    },
  ];
}
